import type { SxProps, Theme } from "@mui/material";

export const headerStyle: SxProps = (theme: Theme) => ({
  overflow: "hidden",
  maxWidth: "100%",
  position: "sticky",
  display: "flex",
  height: 50,
  top: 0,
  py: 1,
  marginBottom: 2,
  alignItems: "center",
  justifyContent: "space-between",
  backgroundColor: theme.palette.box0.main,
  boxShadow: `0 -4px 3px 3px ${theme.palette.box0.main}`,
  borderBottom: "1px solid #ccc",
  flexDirection: "row",
  color: theme.palette.box0.contrastText,
  whiteSpace: "nowrap",
  zIndex: 1100,
});

export const menuButtonStyle: SxProps = {
  fontSize: 12,
};

export const headerAvatarStyle: SxProps = {
  width: 16,
  height: 16,
  ml: 1,
};

export const headerBoxStyle: SxProps = {
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "center",
  width: "100%",
};
